import { CurrencyType } from '../../Wallet/Types/Wallet'
import { MarketingCampaignType } from './MarketingCampaignType'

export interface MarketingCampaignDto {
  id: string
  key: string
  name: string
  type: {
    id: MarketingCampaignType
    name: string
  }
  from: string
  to: string
  status: {
    id: number
    name: string
  }
  termsAndConditionsUrl: null | string
  minDeposit: number
  maxPayout: number
  defaultCurrency: {
    id: CurrencyType
    name: string
  }
  interval: {
    id: number
    name: string
  }
}

export enum MarketingCampaignKey {
  name = 'name',
  type = 'type.name',
  from = 'from',
  to = 'to',
  status = 'status.name',
  lastUpdatedDate = 'lastUpdatedDate',
}

export enum MarketingCampaignFilterKey {
  name = 'Name',
  type = 'Type',
  calculationType = 'CalculationType',
  from = 'From',
  to = 'To',
  status = 'Status',
  attachable = 'Attachable',
}
